import Head from "next/head";
import Hero from "../../components/career/Hero";
import React, { useEffect, useState } from "react";
import PageName from "../../components/pagename/index";
import Main from "../../components/career/Main";
import ContactSection from "../../components/career/Footer";
import { useRouter } from "next/router";
import useLocaleSWR from "../../components/customhooks/useLocalSwr";
import axios from "../../Axios";
import { useTranslations } from "next-intl";

const Career = ({ careers }) => {
  const t = useTranslations("careersHeader");
  const router = useRouter();
  const { data, error } = useLocaleSWR(
    `/user/careers/all-Careers/${router.locale}`
  );

  const readFrom = data ? data.data.result : careers;

  return (
    <>
      <Head>
        <title>Careers | Ascot Enterprise Solutions </title>
      </Head>
      <PageName title={t("pagename")} img="career/Lightbulb" />
      <div className="responsive max-w-[1440px] xl:m-auto ">
        <Hero />
        <Main jobs={readFrom} />
        <ContactSection />
      </div>
    </>
  );
};

export async function getServerSideProps({ locale }) {
  try {
    const { data } = await axios.get(`user/careers/all-Careers/en`);

    return {
      props: {
        careers: data.result,
        messages: require(`../../locales/${locale}.json`),
      },
    };
  } catch (error) {
    return {
      redirect: {
        permenant: false,
        destination: "/404",
      },
    };
  }
}

export default Career;
